/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { useRef, useEffect } from "react";

/**
 * Custom hook for managing filter refs to avoid closure issues
 * @param {Object} filters - Object containing all filter values
 * @returns {React.MutableRefObject} filtersRef - Ref object containing current filter values
 */
export function useFiltersRef(filters) {
  const filtersRef = useRef(filters);

  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  return filtersRef;
}

